export default {
  root: {
    display: 'flex',
    backgroundColor: '#FAFAFA',
    padding: '20px 12px',
    justifyContent: 'space-between',
  },
};
